import jwtDecode from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";

const initialState = {
    email: '',
    nombre: '',
    usuario_id: undefined,
    user: null
};

if (localStorage.getItem('token')) {
    try {

        const decodedToken = jwtDecode(localStorage.getItem('token'));
        if (decodedToken.exp * 1000 < Date.now()) {
            localStorage.removeItem('token');
        } else {
            initialState.user = localStorage.getItem('token');
            initialState.email = decodedToken.email;
            initialState.usuario_id = decodedToken.usuario_id;

        }
    } catch { }
}


export const useAuth = () => {
    const dispatch = useDispatch();
    const authState = useSelector(state => state.auth);
    const login = (userData) => {
        try {
            const decodedToken = jwtDecode(userData.token);
            setTimeout(() => {
                localStorage.removeItem('token');
                dispatch({
                    type: '@auth/logout'
                });
            }, (decodedToken.exp * 1000) - Date.now());
            setTimeout(() => {
                alert("La sesión expirará en 10 minutos");
            }, (decodedToken.exp * 1000) - Date.now() - (1000 * 60 * 10));
        } catch { }
        localStorage.setItem('token', userData.token);
        dispatch({
            type: '@auth/login',
            payload: {
                email: userData.email,
                nombre: userData.nombre,
                usuario_id: userData.usuario_id,
                user: userData.token
            }
        });
    };
    const logout = () => {
        localStorage.removeItem('token');
        dispatch({
            type: '@auth/logout'
        });
    };
    return { authState, login, logout };
};


export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case '@auth/login':
            return {
                ...state,
                ...action.payload
            };
        case '@auth/logout':
            return {
                ...state,
                user: null,
                usuario_id: undefined,
                email: '',
            };
        default:
            return state;
    }
};